/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
export default {
  name: 'shared-models-list',
  components: {
  },
  props: [],
  data () {
    return {
      sharedAlgoList:null,
      sharedAlgoListResults:[],
    }
  },
  computed: {
  },
  mounted () {
    this.getSharedModelsListFunc();
  },
  methods: {
    getSharedModelsListFunc() {
      this.$store.dispatch('getSharedModelsForAiDashFun').then((res) => {
        this.sharedAlgoList = res.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results 
      })
    },
  },
  watch:{
  }
}